module.exports = __webpack_public_path__ + "static/media/game-edition-background.b03af544.png";